import React from "react";
import { useState, useEffect, useMemo } from "react";
import { Container, Row, Col, Button, Modal, Badge } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import Select from "react-select";

import { DateRangePicker, DatePicker } from "rsuite";
import moment from "moment";
import * as Icon from "react-bootstrap-icons";
import { ThreeCircles } from "react-loader-spinner";
import { ToastContainer, toast } from "react-toastify";

import { logout } from "../../utils";

import AgGrid from "../../reusable-components/AgGridComponent/AgGrid";

import "rsuite/dist/rsuite.min.css";
import { makeCygnusApiCall } from "../../api/api";
import { CustomButton } from "../../reusable-components/CustomButtonComponent/button";

function ScheduledReports() {
  const [reportData, setReportData] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [uniqueReportCategories, setUniqueReportCategories] = useState([]);

  const [selectedVendorCategoryOption, setSelectedVendorCategory] = useState(
    []
  );
  const [vendorCategories, setVendorCategories] = useState([]);
  const [vendorsWrtFirm, setVendorsWrtFirm] = useState([]);

  const [scheduledReportDate, setScheduledReportDate] = useState("");
  const [scheduledReportTime, setScheduledReportTime] = useState(new Date());

  const [reportOptions, setReportOptions] = useState([]);
  const [selectedReportsOptions, setSelectedReportsOptions] = useState([]);

  const [scheduledReports, setScheduledReports] = useState([]);
  const [modifiedScheduledReports, setModifiedScheduledReports] = useState([]);

  // modal
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setScheduleDeleteID] = useState(null);
  const handleDeleteModalClose = () => {
    deleteId && deleteScheduledReport(deleteId);
  };
  const handleDeleteModalShow = () => setShowDeleteModal(true);

  const [showEditModal, setShowEditModal] = useState(false);
  const [editScheduledRecordData, setEditScheduledRecordData] = useState(null);
  const handleEditModalClose = () => setShowEditModal(true);
  const [scheduledReportEditDate, setScheduledReportEditDate] = useState("");
  const [scheduledReportEditTime, setScheduledReportEditTime] = useState("");
  const [selectedEditReportsOptions, setEditSelectedReportsOptions] = useState(
    []
  );
  const [selectedEditDaysOptions, setSelectedEditDaysOptions] = useState([]);

  const [filterByDateRange, setFilterByDateRange] = useState("");

  const ranges = [
    {
      label: "Now",
      value: new Date(),
    },
  ];

  const days = [
    { value: "Monday", label: "Monday" },
    { value: "Tuesday", label: "Tuesday" },
    { value: "Wednesday", label: "Wednesday" },
    { value: "Thursday", label: "Thursday" },
    { value: "Friday", label: "Friday" },
    { value: "Saturday", label: "Saturday" },
    { value: "Sunday", label: "Sunday" },
  ];
  const [selectedDaysOptions, setSelectedDaysOptions] = useState([]);

  const containerStyle = useMemo(() => ({ width: "100%", height: "auto" }), []);
  const gridStyle = useMemo(() => ({ height: 400, width: "100%" }), []);

  const getRequestOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };

  // Get VEndor Categories
  const getVendorCategories = async () => {
    const data = await makeCygnusApiCall({
      type: "GET",
      payload: {},
      url: "/vendors/",
      show_message: false,
      customized_success_message: "Got your vendors.",
      customized_failure_message: "Unable to fetch the vendors, please try again. If the problem persists, please contact support and attach a screenshot.",
      customized_error_message: "Error occured while fetching vendors, please contact support and attach a screenshot.",
      isblob: false
    })
    if (data.success) {
      if (data["Data"]) {
        setVendorCategories(
          [...new Set(data["Data"].map((el) => el.Category))].map((el) => {
            return {
              value: el,
              label: el,
            };
          })
        );
      }
    }
  }

  // Get all Vendor Details
  const getvendorsWrtFirm = async () => {
    const data = await makeCygnusApiCall({
      type: "GET",
      payload: {},
      url: "/firm_vendors/",
      show_message: false,
      customized_success_message: "Got your vendor data.",
      customized_failure_message: "Unable to fetch the vendor data, please try again. If the problem persists, please contact support and attach a screenshot.",
      customized_error_message: "Error occured while fetching vendor data, please contact support and attach a screenshot.",
      isblob: false
    })
    if (data.success) {
      setVendorsWrtFirm(data["Data"].map((el) => el.FirmVendorId));
    }
  };

  const deleteScheduledReport = async (scheduledReportId) => {
    if (scheduledReportId) {
      const data = await makeCygnusApiCall({
        type: "DELETE",
        payload: { SchedulerId: scheduledReportId },
        url: "/scheduled_reports/",
        show_message: true,
        customized_success_message: "Report data deleted.",
        customized_failure_message: "Unable to delete the report data, please try again. If the problem persists, please contact support and attach a screenshot.",
        customized_error_message: "Error occured while deleting report data, please contact support and attach a screenshot.",
        isblob: false
      })
      if (data.success) {
        setScheduleDeleteID(null);
        setShowDeleteModal(false);
        getScheduledReports();
      }
    }
  };

  // Get Scheduled Reports
  const getScheduledReports = async () => {
    const data = await makeCygnusApiCall({
      type: "GET",
      payload: {},
      url: "/scheduled_reports/",
      show_message: false,
      customized_success_message: "Got your scheduled report data.",
      customized_failure_message: "Unable to fetch the scheduled report data, please try again. If the problem persists, please contact support and attach a screenshot.",
      customized_error_message: "Error occured while fetching scheduled report data, please contact support and attach a screenshot.",
      isblob: false
    })
    if (data.success) {
      let modifiedData = data["Data"].map((el) => {
        // console.log("============", el.Days.split(",").join(" , "));
        return {
          SchedulerId: el.SchedulerId,
          VendorCategory: el.VendorCategory,
          ReportIds: el.ReportIds.substr(1, el.ReportIds.length - 2),
          ReportNames: el.ReportNames.substr(1, el.ReportNames.length - 2),
          StartDate: el.StartDate,
          EndDate: el.EndDate,
          TriggerTime: el.TriggerTime,
          Days: el.Days.substr(1, el.Days.length - 2),
        };
      });
      setScheduledReports(modifiedData);
      setModifiedScheduledReports(modifiedData);
    }
  };

  const resetScheduledReport = () => {
    setSelectedVendorCategory([]);
    setScheduledReportDate("");
    setScheduledReportTime(new Date());
    setSelectedReportsOptions([]);
    setSelectedDaysOptions([]);
    console.log(
      scheduledReportDate,
      scheduledReportDate,
      selectedReportsOptions,
      selectedDaysOptions
    );
  };

  const isWithinRange = (start1, end1, start2, end2) => {
    let filterStart = moment(start1).format("YYYY-MM-DD");
    let filterEnd = moment(end1).format("YYYY-MM-DD");
    let dataStart = moment(start2).format("YYYY-MM-DD");
    let dataEnd = moment(end2).format("YYYY-MM-DD");
    //console.log("________ IS WITHIN RANGE START_____________");
    console.log(
      `filterStart ${filterStart}  end1 ${filterEnd}   dataStart  ${dataStart} dataEnd ${dataEnd}`
    );
    //console.log("________ IS WITHIN RANGE END_____________");
    console.log(
      "::::::::::Start2 ::::::::::",
      // moment(filterStart).isBetween(dataStart, dataEnd)
      moment(filterStart).isSameOrAfter(dataStart) &&
      moment(filterEnd).isSameOrBefore(dataEnd),
      moment
    );
    // console.log(
    //   "::::::::::end2 ::::::::::",
    //   moment(filterEnd).isBetween(dataStart, dataEnd)
    //   // moment(end1).isSameOrAfter(start2) && moment(end1).isSameOrBefore(end2)
    // );

    return (
      moment(filterStart).isSameOrAfter(dataStart) &&
      moment(filterEnd).isSameOrBefore(dataEnd)
    );
  };
  const [saveScheduledReportApiFlag, setSaveScheduledReportApiFlag] = useState()
  const saveScheduledReport = async (type, saveId) => {
    setSaveScheduledReportApiFlag(true)
    const finalData = {
      VendorCategory: "Workflow",
      ReportIds: selectedReportsOptions.map((el) => el.value).toString(),
      ReportNames: selectedReportsOptions.map((el) => el.label).toString(),
      StartDate: moment(scheduledReportDate[0]).format("YYYY-MM-DD"),
      EndDate: moment(scheduledReportDate[1]).format("YYYY-MM-DD"),
      TriggerTime: moment(scheduledReportTime).format("hh:mm:ss a"),
      Days: selectedDaysOptions.map((el) => el.value).toString(),
    };

    const finalDataEditted = {
      VendorCategory: "Workflow",
      SchedulerId: saveId,
      ReportIds: selectedEditReportsOptions.map((el) => el.value).toString(),
      ReportNames: selectedEditReportsOptions.map((el) => el.label).toString(),
      StartDate: moment(scheduledReportEditDate[0]).format("YYYY-MM-DD"),
      EndDate: moment(scheduledReportEditDate[1]).format("YYYY-MM-DD"),
      TriggerTime: moment(scheduledReportEditTime).format("hh:mm:ss a"),
      Days: selectedEditDaysOptions.map((el) => el.value).toString(),
    };

    const data = await makeCygnusApiCall({
      type: type == "new" ? "POST" : "PUT",
      payload: type == "new" ? finalData : finalDataEditted,
      url: "/scheduled_reports/",
      show_message: false,
      customized_success_message: type == "new" ? "Reports scheduled Successfully." : "Report scheduled and saved successfully.",
      customized_failure_message: "Unable to schedule your report, please try again. If the problem persists, please contact support and attach a screenshot.",
      customized_error_message: "Error occured while scheduling your report, please contact support and attach a screenshot.",
      isblob: false
    })
    if (data.success) {
      getScheduledReports();
      if (type == "edit") {
        setShowEditModal(false);
      }
    }
    setSaveScheduledReportApiFlag(false)
  };

  useEffect(() => {
    getvendorsWrtFirm();
    getVendorCategories();
    getScheduledReports();
  }, []);

  useEffect(() => {
    const getAutomatedReports = async () => {
      if (vendorsWrtFirm) {
        const data = await makeCygnusApiCall({
          type: "GET",
          payload: {},
          url: "/automated_reports/",
          show_message: false,
          customized_success_message: "Got your reports data.",
          customized_failure_message: "Unable to fetch the reports data, please try again. If the problem persists, please contact support and attach a screenshot.",
          customized_error_message: "Error occured while fetching reports data, please contact support and attach a screenshot.",
          isblob: false
        })
        if (data.success) {
          console.log("Firm Reports", data);
          setReportData(data.Data);
          const dataSource =
            vendorsWrtFirm &&
            data.Data &&
            data.Data.map((el) => {
              return {
                reportid: el.reportid,
                reportname: el.reportname,
                reportdescription: el.reportdescription,
                reportcategorycode: el.reportcategorycode,
                endpointname: el.endpointname,
                schedulable: el.schedulable,
                storedprocedurename: el.storedprocedurename,
                vendorcategory: el.vendorcategory,
                vendorid: el.vendorid,
                vendorname: el.vendorid,
                active: el.active,
              };
            });

          setUniqueReportCategories([
            ...new Set(dataSource.map((el) => el.reportcategorycode)),
          ]);

          let abc = [
            ...new Set(dataSource.map((el) => el.reportcategorycode)),
          ].map((el) => {
            return {
              label: el,
              options: dataSource
                .filter((elem) => {
                  return (
                    elem.reportcategorycode == el &&
                    elem.active == "Y" &&
                    vendorsWrtFirm.includes(Number(elem.vendorid))
                  );
                })
                .map((item) => {
                  return {
                    value: item.reportdescription,
                    label: item.reportname,
                  };
                }),
            };
          });

          setDataSource(dataSource);
          setReportOptions(abc);

          return data;
        }
      }
    }
    getAutomatedReports()
  }, [vendorsWrtFirm]);

  const setDate = (val) => {
    setScheduledReportDate(val);
  };

  const setEditDate = (val) => {
    setScheduledReportEditDate(val);
  };

  const handleSetFilterDateRange = (val) => {
    setFilterByDateRange(val);

    if (val && val[0] && val[1]) {
      const start1 = moment(moment(val[0]).format("YYYY-MM-DD"));
      const end1 = moment(moment(val[1]).format("YYYY-MM-DD"));

      setModifiedScheduledReports(
        scheduledReports
          .map((el) => {
            return isWithinRange(
              start1,
              end1,
              moment(el.StartDate),
              moment(el.EndDate)
            )
              ? el
              : "not in range";
            // console.log(
            //   isWithinRange(start1, end1, moment(el.StartDate), moment(el.EndDate))
            //     ? el
            //     : "not in range"
            // );
            // return isWithinRange(
            //   start1,
            //   end1,
            //   moment(el.StartDate),
            //   moment(el.EndDate)
            // )
            //   ? el
            //   : "not in range";
          })
          .filter((el) => el != "not in range")
      );
    }
  };

  const setTime = (val) => {
    setScheduledReportTime(val);
  };

  const setEditTime = (val) => {
    setScheduledReportEditTime(val);
  };

  const DeleteButton = ({ data }) => {
    const deleteReportHandler = () => {
      setShowDeleteModal(true);
      setScheduleDeleteID(data.SchedulerId);
    };

    return (
      <button className="grid-button" onClick={deleteReportHandler}>
        <Icon.TrashFill />
      </button>
    );
  };

  const EditButton = ({ data }) => {
    const editReportHandler = () => {
      let reportIds = data.ReportIds;
      let reportNames = data.ReportNames;
      let editedReports = reportIds.split(",").map((el, i) => {
        return {
          value: el,
          label: reportNames.split(",")[i],
        };
      });
      setEditScheduledRecordData(data);
      setEditSelectedReportsOptions(editedReports);
      setScheduledReportEditDate([
        new Date(data.StartDate),
        new Date(data.EndDate),
      ]);
      let triggerTime = moment(data.TriggerTime, "hh:mm:ss a");
      setScheduledReportEditTime(new Date(triggerTime));

      let gotDays = data.Days.split(",");

      setSelectedEditDaysOptions(
        days.filter((elem) => gotDays.includes(elem.value))
      );
      setShowEditModal(true);
    };

    return (
      <button className="grid-button" onClick={editReportHandler}>
        <Icon.PencilSquare />
      </button>
    );
  };

  const columnDefs = [
    { field: "SchedulerId", hide: true },
    { field: "VendorCategory" },
    { field: "StartDate" },
    { field: "EndDate" },
    { field: "TriggerTime" },
    { field: "Days" },
    { field: "ReportIds", hide: true },
    { field: "ReportNames" },
    { field: "Delete", cellRendererFramework: DeleteButton },
    { field: "Edit", cellRendererFramework: EditButton },
  ];

  const sortable = true;
  const filter = true;
  const resizable = true;

  // console.log("SELECTED REPORT OPTIONS : ", selectedReportsOptions);
  // console.log("FILTERED RANGES : ", filterByDateRange);

  return (
    <Container fluid>
      <Modal show={showDeleteModal}>
        <Modal.Header>
          <Modal.Title>Delete Scheduled Report</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the scheduled Reports
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="warning" onClick={handleDeleteModalClose}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showEditModal} size="lg">
        <Modal.Header>
          <Modal.Title>Edit Scheduled Report</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {editScheduledRecordData && (
            <Row>
              <Col
                xs={12}
                className="scheduledReports-left"
                style={{
                  maxHeight: "40vh",
                  minHeight: "50vh",
                  background: "#fff",
                }}
              >
                <Row className="mt-5">
                  <Col xs={12} className="mb-2">
                    <b className="mb-2">Select Vendor Category</b>
                  </Col>
                  <Col xs={12} style={{ zIndex: 4 }}>
                    <Select
                      defaultValue={[
                        {
                          value: editScheduledRecordData.VendorCategory,
                          label: editScheduledRecordData.VendorCategory,
                        },
                      ]}
                      // onChange={setSelectedVendorCategory}
                      isDisabled={true}
                      options={vendorCategories}
                    />
                  </Col>
                </Row>
                {editScheduledRecordData.VendorCategory &&
                  editScheduledRecordData.VendorCategory == "Workflow" && (
                    <Row className="mt-5">
                      <Col xs={12} className="mb-2">
                        <b className="mb-2">Select Reports</b>
                      </Col>
                      <Col xs={12} style={{ zIndex: 3 }}>
                        <Select
                          defaultValue={selectedEditReportsOptions}
                          onChange={setEditSelectedReportsOptions}
                          options={reportOptions}
                          styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          }}
                          isMulti
                        />
                      </Col>
                    </Row>
                  )}
                <Row className="mt-5">
                  <Col xs={7} className="mb-2">
                    <b className="mb-2">Select Start and End Date </b>
                  </Col>
                  <Col xs={5} className="mb-2">
                    <b className="mb-2">Select Trigger Time</b>
                  </Col>
                  <Col xs={7} style={{ zIndex: 1 }}>
                    <DateRangePicker
                      value={scheduledReportEditDate}
                      format="MM-dd-yyyy"
                      placeholder="Start-date to End-date"
                      onChange={setEditDate}
                    />
                  </Col>
                  <Col xs={5} style={{ zIndex: 1 }}>
                    <DatePicker
                      value={scheduledReportEditTime}
                      format="hh:mm:ss aa"
                      placeholder="Trigger time"
                      showMeridian
                      onChange={setEditTime}
                    />
                  </Col>
                </Row>
                <Row className="mt-5">
                  <Col xs={12} className="mb-2">
                    <b>Select Days</b>
                  </Col>
                  <Col xs={12} style={{ zIndex: 2 }}>
                    <Select
                      defaultValue={selectedEditDaysOptions}
                      onChange={setSelectedEditDaysOptions}
                      options={days}
                      isMulti
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Cancel
          </Button>
          <CustomButton
            progress={saveScheduledReportApiFlag}
            onclick={() => saveScheduledReport("edit", editScheduledRecordData.SchedulerId)}
            content={saveScheduledReportApiFlag ? "Editing Scheduled Report" : "Edit Scheduled Report"}
            disable={saveScheduledReportApiFlag}
          />
          {/* <Button variant="warning" onClick={handleEditModalClose}>
            Edit
          </Button> */}
        </Modal.Footer>
      </Modal>

      <Row>
        <Col xs={12}>
          <Row style={{ background: "rgb(251, 242, 207)", padding: "5px" }}>
            <NavLink
              to="/automatedReports"
              className="black"
              style={{
                padding: "5px",
                fontWeight: "bold",
                cursor: "pointer",
                color: "#000 !important",
                width: "10%",
                display: "inline-block",
                textAlign: "center",
              }}
            >
              <span> On Demand Reports</span>
            </NavLink>

            <span
              className="secondary-menu-active"
              style={{
                padding: "5px",
                fontWeight: "bold",
                cursor: "pointer",
                width: "10%",
                display: "inline-block",
                textAlign: "center",
              }}
            >
              {" "}
              Scheduled Reports
            </span>
            <NavLink
              to="/automatedReports/downloadedReports"
              className="black"
              style={{
                padding: "5px",
                fontWeight: "bold",
                cursor: "pointer",
                color: "#000",
                width: "10%",
                display: "inline-block",
                textAlign: "center",
              }}
            >
              <span>Downloaded Reports</span>
            </NavLink>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col xs={3} className="scheduledReports-left">
          <h2 className="display-6 mt-4">Create Schedule Reports</h2>
          <hr />
          <Row className="mt-5">
            <Col xs={12} className="mb-2">
              <b className="mb-2">Select Vendor Category</b>
            </Col>
            <Col xs={12} style={{ zIndex: 4 }}>
              <Select
                defaultValue={selectedVendorCategoryOption}
                onChange={setSelectedVendorCategory}
                options={vendorCategories}
              />
            </Col>
          </Row>
          {selectedVendorCategoryOption &&
            selectedVendorCategoryOption.value == "Workflow" && (
              <Row className="mt-5">
                <Col xs={12} className="mb-2">
                  <b className="mb-2">Select Reports</b>
                </Col>
                <Col xs={12} style={{ zIndex: 3 }}>
                  <Select
                    defaultValue={selectedReportsOptions}
                    onChange={setSelectedReportsOptions}
                    options={reportOptions}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    isMulti
                  />
                </Col>
              </Row>
            )}
          <Row className="mt-5">
            <Col xs={7} className="mb-2">
              <b className="mb-2">Select Start and End Date </b>
            </Col>
            <Col xs={5} className="mb-2">
              <b className="mb-2">Select Trigger Time</b>
            </Col>
            <Col xs={7} style={{ zIndex: 1 }}>
              <DateRangePicker
                value={scheduledReportDate}
                placeholder="Start-date to End-date"
                format="MM-dd-yyyy"
                onChange={setDate}
              />
            </Col>
            <Col xs={5} style={{ zIndex: 1 }}>
              <DatePicker
                value={scheduledReportTime}
                format="hh:mm:ss aa"
                showMeridian
                placeholder="Trigger time"
                style={{ width: 260 }}
                onChange={setTime}
              />
            </Col>
          </Row>
          <Row className="mt-5">
            <Col xs={12} className="mb-2">
              <b>Select Days</b>
            </Col>
            <Col xs={12} style={{ zIndex: 2 }}>
              <Select
                value={selectedDaysOptions}
                onChange={setSelectedDaysOptions}
                isClearable
                options={days}
                isMulti
              />
            </Col>
          </Row>
          <Row className="mt-5">
            <Col xs={5}></Col>
            <Col xs={7}>
              <Button
                variant="secondary"
                onClick={() => resetScheduledReport()}
              >
                Reset
              </Button>
              <CustomButton
                progress={saveScheduledReportApiFlag}
                onclick={() => saveScheduledReport("new", null)}
                content={saveScheduledReportApiFlag ? "Creating Scheduled Report" : "Create Scheduled Report"}
                disable={saveScheduledReportApiFlag}
              />
            </Col>
          </Row>
        </Col>
        <Col xs={9} className="scheduledReports-right">
          <h2 className="display-6 mt-4">Scheduled Reports</h2>
          <hr />
          <Row className="filter-panel-scheduled-reports">
            <Col xs={5} style={{ padding: 0 }}>
              <Badge
                bg="info"
                text="dark"
                style={{ width: "100%", fontSize: "13px" }}
              >
                Filter Schedules which are running during the selected date
                range
                <br></br>
              </Badge>
              <DateRangePicker
                value={filterByDateRange}
                format="MM-dd-yyyy"
                placeholder="Start-date to End-date"
                onChange={handleSetFilterDateRange}
                onClean={() => setModifiedScheduledReports(scheduledReports)}
              />
            </Col>
            <Col></Col>
          </Row>
          {scheduledReports && scheduledReports.length ? (
            <div style={containerStyle} className="mt-3">
              <div className="ag-theme-alpine" style={gridStyle}>
                <AgGrid
                  rowData={modifiedScheduledReports}
                  columnDefs={columnDefs}
                  sortable={sortable}
                  filter={filter}
                  resizable={resizable}
                  height="70vh"
                />
              </div>
            </div>
          ) : (
            <div style={{ position: "relative", top: "50px", left: "43%" }}>
              <ThreeCircles
                height="100"
                width="100"
                color="#4fa94d"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel="three-circles-rotating"
                outerCircleColor="var(--theme1_primary)"
                innerCircleColor="var(--theme1_secondary)"
                middleCircleColor="var(--theme1_tertiary)"
              />
              <h5
                style={{
                  position: "relative",
                  left: "-5%",
                  padding: "10px",
                }}
              >
                Fetching Scheduled Reports
              </h5>
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default ScheduledReports;
